import { render, staticRenderFns } from "./Fetching.vue?vue&type=template&id=0ee92782&scoped=true&"
import script from "./Fetching.vue?vue&type=script&lang=js&"
export * from "./Fetching.vue?vue&type=script&lang=js&"
import style0 from "./Fetching.vue?vue&type=style&index=0&id=0ee92782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee92782",
  null
  
)

export default component.exports